module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel box-collapse border-color-skin",
    attrs: {
      "id": "hres80x-history-heal-illness1"
    }
  }, [_c('div', {
    staticClass: "box-header with-border box-header-collapse collapsed  tab-header",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#historyHealIllness1"
    }
  }, [_c('h3', {
    staticClass: "box-title color-skin"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o margin-r-5 margin-r-5"
  }), _vm._v(" " + _vm._s(_vm.labels['HRES80XP1']['10']) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse tab-detail collapse in",
    attrs: {
      "id": "historyHealIllness1"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "detail detail-responsive panel-detail-filter"
  }, [_c('table', {
    staticClass: "table-1"
  }, [_c('tr', [_c('td', {
    staticClass: "bg-color-skin text-center",
    staticStyle: {
      "width": "5%"
    }
  }, [_vm._v(_vm._s(_vm.labels['HRES80XP1']['30']))]), _vm._v(" "), _c('td', {
    staticClass: "bg-color-skin text-center",
    staticStyle: {
      "width": "35%"
    }
  }, [_vm._v(_vm._s(_vm.labels['HRES80XP1']['40']))]), _vm._v(" "), _c('td', {
    staticClass: "bg-color-skin text-center",
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v(_vm._s(_vm.labels['HRES80XP1']['50']) + _vm._s(_vm.labels['HRES80XP1']['60']))]), _vm._v(" "), _c('td', {
    staticClass: "bg-color-skin text-center",
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v(_vm._s(_vm.labels['HRES80XP1']['70']) + _vm._s(_vm.labels['HRES80XP1']['80']))]), _vm._v(" "), _c('td', {
    staticClass: "bg-color-skin text-center",
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.labels['HRES80XP1']['90']))])]), _vm._v(" "), _c('heal-illness1-detail', {
    attrs: {
      "numseq": _vm.labels['HRES80XP1']['100'],
      "description": _vm.labels['HRES80XP1']['190'],
      "value": _vm.dataHisHeal.flgheal1,
      "remark": _vm.dataHisHeal.remark1
    }
  }), _vm._v(" "), _c('heal-illness1-detail', {
    attrs: {
      "numseq": _vm.labels['HRES80XP1']['110'],
      "description": _vm.labels['HRES80XP1']['200'],
      "value": _vm.dataHisHeal.flgheal2,
      "remark": _vm.dataHisHeal.remark2
    }
  }), _vm._v(" "), _c('heal-illness1-detail', {
    attrs: {
      "numseq": _vm.labels['HRES80XP1']['120'],
      "description": _vm.labels['HRES80XP1']['210'],
      "value": _vm.dataHisHeal.flgheal3,
      "remark": _vm.dataHisHeal.remark3
    }
  }), _vm._v(" "), _c('heal-illness1-detail', {
    attrs: {
      "numseq": _vm.labels['HRES80XP1']['130'],
      "description": _vm.labels['HRES80XP1']['220'],
      "value": _vm.dataHisHeal.flgheal4,
      "remark": _vm.dataHisHeal.remark4
    }
  }), _vm._v(" "), _c('heal-illness1-detail', {
    attrs: {
      "numseq": _vm.labels['HRES80XP1']['140'],
      "description": _vm.labels['HRES80XP1']['230'],
      "value": _vm.dataHisHeal.flgheal5,
      "remark": _vm.dataHisHeal.remark5
    }
  }), _vm._v(" "), _c('heal-illness1-detail', {
    attrs: {
      "numseq": _vm.labels['HRES80XP1']['150'],
      "description": _vm.labels['HRES80XP1']['240'],
      "value": _vm.dataHisHeal.flgheal6,
      "remark": _vm.dataHisHeal.remark6
    }
  }), _vm._v(" "), _c('heal-illness1-detail', {
    attrs: {
      "numseq": _vm.labels['HRES80XP1']['160'],
      "description": _vm.labels['HRES80XP1']['250'],
      "value": _vm.dataHisHeal.flgheal7,
      "remark": _vm.dataHisHeal.remark7
    }
  }), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.labels['HRES80XP1']['170']))]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.labels['HRES80XP1']['260']))])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', {
    staticClass: "table-2",
    attrs: {
      "colspan": "5"
    }
  }, [_c('table', [_c('tr', [_c('td', {
    staticStyle: {
      "width": "24px"
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "flgheal80"
    },
    domProps: {
      "checked": _vm.dataHisHeal.flgheal8 === '0'
    }
  })]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "280px"
    }
  }, [_vm._v(_vm._s(_vm.labels['HRES80XP1']['270']))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "60px"
    }
  }), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "240px"
    }
  }), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "60px"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "flgheal81"
    },
    domProps: {
      "checked": _vm.dataHisHeal.flgheal8 === '1'
    }
  })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.labels['HRES80XP1']['280']))]), _vm._v(" "), _c('td', [_c('input', {
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.dataHisHeal.qtysmok
    }
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "10"
    }
  }, [_vm._v(_vm._s(_vm.labels['HRES80XP1']['290']))])]), _vm._v(" "), _c('tr', [_c('td', [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "flgheal82"
    },
    domProps: {
      "checked": _vm.dataHisHeal.flgheal8 === '2'
    }
  })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.labels['HRES80XP1']['300']))]), _vm._v(" "), _c('td', [_c('input', {
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.dataHisHeal.qtyyear
    }
  })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.labels['HRES80XP1']['310']))]), _vm._v(" "), _c('td', [_c('input', {
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.dataHisHeal.qtymth
    }
  })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.labels['HRES80XP1']['320']))])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.labels['HRES80XP1']['330']))]), _vm._v(" "), _c('td', [_c('input', {
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.dataHisHeal.qtysmok2
    }
  })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.labels['HRES80XP1']['340']))])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.labels['HRES80XP1']['180']))]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.labels['HRES80XP1']['350']))])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', {
    staticClass: "table-2",
    attrs: {
      "colspan": "5"
    }
  }, [_c('table', [_c('tr', [_c('td', {
    staticStyle: {
      "width": "24px"
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "flgheal90"
    },
    domProps: {
      "checked": _vm.dataHisHeal.flgheal9 === '0'
    }
  })]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "280px"
    }
  }, [_vm._v(_vm._s(_vm.labels['HRES80XP1']['360']))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "24px"
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "flgheal91"
    },
    domProps: {
      "checked": _vm.dataHisHeal.flgheal9 === '1'
    }
  })]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "280px"
    },
    attrs: {
      "colspan": "9"
    }
  }, [_vm._v(_vm._s(_vm.labels['HRES80XP1']['370']))])]), _vm._v(" "), _c('tr', [_c('td', [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "flgheal92"
    },
    domProps: {
      "checked": _vm.dataHisHeal.flgheal9 === '2'
    }
  })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.labels['HRES80XP1']['380']))]), _vm._v(" "), _c('td', [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "flgheal93"
    },
    domProps: {
      "checked": _vm.dataHisHeal.flgheal9 === '3'
    }
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "9"
    }
  }, [_vm._v(_vm._s(_vm.labels['HRES80XP1']['390']))])]), _vm._v(" "), _c('tr', [_c('td', [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "flgheal94"
    },
    domProps: {
      "checked": _vm.dataHisHeal.flgheal9 === '4'
    }
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "11"
    }
  }, [_vm._v(_vm._s(_vm.labels['HRES80XP1']['400']))])]), _vm._v(" "), _c('tr', [_c('td', [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "flgheal95"
    },
    domProps: {
      "checked": _vm.dataHisHeal.flgheal9 === '5'
    }
  })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.labels['HRES80XP1']['410']))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "60px"
    },
    attrs: {
      "colspan": "3"
    }
  }, [_c('input', {
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.dataHisHeal.qtyyear9
    }
  })]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "240px"
    }
  }, [_vm._v(_vm._s(_vm.labels['HRES80XP1']['420']))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "60px"
    }
  }, [_c('input', {
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.dataHisHeal.qtymth9
    }
  })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.labels['HRES80XP1']['430']))])])])])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-595d10bf!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres80x/historyHealIllness1.vue
// module id = 3788
// module chunks = 1